module.exports = __webpack_public_path__ + "static/media/home.a494888a.svg";